import { makeStyles } from 'tss-react/mui'
import { ExternalPlatformType } from './types'

export const useStyles = makeStyles<{
  isExternal?: boolean
  externalPlatformType?: ExternalPlatformType
}>()((theme, { isExternal, externalPlatformType }) => ({
  root: {
    background: theme.palette.bg.main,
    margin: theme.spacing(-4),
    ...(externalPlatformType === ExternalPlatformType.IMPARTNER
      ? { marginTop: theme.spacing(-2.5) }
      : {}),
  },
  container: {
    height: 'calc(100vh - 130px)',
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(isExternal ? 2 : 4, 5),
    borderRadius: theme.spacing(1),
    textAlign: 'left',
  },
  modalText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: theme.spacing(52.5),
  },
  nameBoldText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px ',
    letterSpacing: '0.1px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  emptyProductContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(6, 0),
    borderRadius: theme.spacing(1),
  },
  emptyProductInnerContainer: {
    height: theme.spacing(35.5),
    display: 'flex',
    flexDirection: 'row',
  },
  leftContainer: {
    display: 'flex',
  },
  thumbnailImages: {
    width: theme.spacing(34),
    height: theme.spacing(35.5),
    borderRadius: theme.spacing(1),
  },
  rightContainer: {
    width: theme.spacing(69.25),
    height: theme.spacing(35.5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: theme.spacing(6),
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    fontSize: '22px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
    letterSpacing: '0.25px',
  },
  subHeadingContainer: {
    marginTop: theme.spacing(3),
  },
  subHeading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  dropDownContainer: {
    marginTop: theme.spacing(5),
    display: 'flex',
    flexDirection: 'row',
  },
  cloudChangeContainer: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  productListing: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'column',
  },
  tableWrapper: {
    height: 'auto',
    overflowY: 'auto',
    width: '100%',
  },
  containerAdmin: {
    paddingLeft: 'inherit',
    paddingRight: theme.spacing(4),
    paddingTop: 'inherit',
    paddingBottom: theme.spacing(4),
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(-1),
  },
  submitButton: {
    marginRight: theme.spacing(3),
  },
  listingActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(5),
    marginLeft: 'auto',
    paddingRight: theme.spacing(3),
  },
  cloudSelectorBox: {
    width: theme.spacing(27.5),
    height: theme.spacing(5.5),
  },
  modalIcon: {
    width: theme.spacing(2.5),
    height: theme.spacing(2),
  },
  toolTipView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dropdownAndProduct: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(3),
  },
  scroll: {
    height: 'calc(100vh - 100px)',
    overflowY: 'scroll',
    '&::-webkit-scrollbar-track': {
      borderRadius: '18px',
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: theme.palette.bgPrimary.main,
    },
    '&::-webkit-scrollbar-thumb': {
      width: '8px',
      borderRadius: '18px',
      backgroundColor: theme.palette.bgSecondary.main,
    },
  },
  productNameWrapper: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'row',
  },
  productNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  dropdownButton: {
    width: theme.spacing(18.5),
    '& span': {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
  noProductsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: theme.spacing(16),
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.description,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    marginTop: theme.spacing(3.75),
  },
}))
